import { Link } from "react-router-dom";
import styled from "styled-components";

export const StyledContainer = styled.div`
  position: relative;
  display: flex;
  gap: 0.875rem;
  height: 12rem;
  max-height: 9.9375rem;
  width: 100%;
  padding: 0 14px;

  @media only screen and (max-width: 960px) {
    height: unset;
    max-height: unset;
    flex-direction: column;
  }
`;

export const StyledLink = styled(Link)`
  position: relative;
  display: flex;
  border: 2px solid #ee0000;
  border-radius: 1.125rem;
  height: 100%;
  cursor: pointer;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 0px;
  padding: 0.75rem 1.0625rem;
  text-decoration: unset;
  transform: translateZ(0);
  -webkit-font-smoothing: subpixel-antialiased;
  transition: all 0.1s;
  background-color: #ffffff;
  z-index: unset;

  /* Match the guidelines home tiles' arrow weight. That arrow is an icon-font
     glyph with a 64/1024 em shaft at 37px, i.e. ~2.31px. The VDS right-arrow
     is a filled path 1.145 units thick in a 21.6 viewBox, so at XLarge (28px)
     the fill alone is ~1.48px; a 0.64-unit stroke (0.32 each side) brings it
     to ~2.31px. */
  svg path {
    stroke: #ee0000;
    stroke-width: 0.64;
    stroke-linejoin: round;
  }

  h1, h2, h3, h4, h5, h6, p, span {
    font-size: 2rem;
    line-height: 1.8125rem;
  }

  &:hover {
    transform: scale(1.025);
    z-index: 1;
    background-color: #ee0000;

    h1, h2, h3, h4, h5, h6, p, span {
      color: #ffffff !important;
    }
    svg,
    svg path {
      fill: #ffffff !important;
      stroke: #ffffff !important;
    }
  }

  &.active {
    background-color: #ee0000;

    svg path {
      stroke: #ffffff;
    }
  }
  
`;
